import { Injectable } from '@angular/core';

export interface FiltroBuscaEstado {
  filtros?: any[];
  paginacao?: {
    page: number;
    pageSize: number;
    ordenation?: string;
  };
  regiao?: any;
  termo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FiltroBuscaEstadoService {
  private readonly STORAGE_KEY = 'redeobras-filtro-busca-estado';

  salvar(moduleId: number | string, estado: FiltroBuscaEstado): void {
    try {
      const todos = this.recuperarTodos();
      todos[String(moduleId)] = estado;
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(todos));
    } catch (error) {
      console.warn('[FiltroBuscaEstado] Erro ao salvar estado:', error);
    }
  }

  recuperar(moduleId: number | string): FiltroBuscaEstado | null {
    try {
      const todos = this.recuperarTodos();
      return todos[String(moduleId)] || null;
    } catch (error) {
      console.warn('[FiltroBuscaEstado] Erro ao recuperar estado:', error);
      return null;
    }
  }

  limpar(moduleId?: number | string): void {
    try {
      if (moduleId == null) {
        sessionStorage.removeItem(this.STORAGE_KEY);
        return;
      }
      const todos = this.recuperarTodos();
      delete todos[String(moduleId)];
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(todos));
    } catch (error) {
      console.warn('[FiltroBuscaEstado] Erro ao limpar estado:', error);
    }
  }

  private recuperarTodos(): Record<string, FiltroBuscaEstado> {
    try {
      const raw = sessionStorage.getItem(this.STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      return typeof parsed === 'object' && parsed !== null ? parsed : {};
    } catch (error) {
      return {};
    }
  }
}
